import styled from 'styled-components';

const PageTitle = ({ title }: any) => {
  return <Title>{title}</Title>;
};
export default PageTitle;

const Title = styled.div`
  font-size: 32px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;
